import React, { useEffect, useState } from "react";
import { User } from "../../../models/Master/User";
import useStyles from "../MasterData.css";
import translation from "../../../i18n/i18.json";
import AllActions from "../../../actions";
import { useDispatch } from "react-redux";
import EditIcon from "@material-ui/icons/Edit";
import { FormError } from "../../../models/FormValidation/FormError";
import { FormFieldMeta } from "../../../models/FormValidation/FormFieldMeta";
import { SBU } from "../../../models/SBU";
import { MasterMetaDataService } from "../../../services/MasterMetaDataService";
import { MasterDataService } from "../../../services/MasterDataService";
import { MasterDataUtil } from "../../../utils/masterData/MasterDataUtil";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import HighlightOffOutlinedIcon from "@material-ui/icons/HighlightOffOutlined";

import {
  Chip,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormLabel,
  Grid,
  MenuItem,
  Select,
  Switch,
  TextField,
  ListItemText,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@material-ui/core";
import {
  InforDisplyaDuration,
  SCF_ALLOWED_COMPANY_CODES,
  ES_Roles,
  App_Roles,
  VendorCategoryData
} from "../../../constants/AppConstants";
import { Cluster } from "../../../models/Cluster";
import { UserRole } from "../../../models/UserRole";
import { FormUtil } from "../../../utils/FormUtil";
import { FormValidateData } from "../../../models/FormValidation/FormValidateData";
import { UserCompany } from "../../../models/UserCompany";
import { UserCluster } from "../../../models/UserCluster";
import { UserRMCategory } from "../../../models/UserRMCategory";
import { UserProcurementCategory } from "../../../models/UserProcurementCategory";
import { UserProcurementSubCategory } from "../../../models/UserProcurementSubCategory";
import CategoryAddDialog from "./CategoryAddDialog";

//import { constants } from "os";

interface UserAddDialogProps {
  open: boolean;
  handleClose: any;
  dataObj: User;
  setDataObj: any;
  sbuList: SBU[];
  userRolesList: UserRole[];
  clustersList: Cluster[];
  successUpdate: any;
  userRmCategoryList: UserRMCategory[];
  userProcurementCategoryList: UserProcurementCategory[];
  userProcurementSubCategoryList: UserProcurementSubCategory[];
}

export default function UserAddDialog(props: UserAddDialogProps) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    open,
    handleClose,
    dataObj,
    setDataObj,
    sbuList,
    userRolesList,
    clustersList,
    successUpdate,
    userRmCategoryList,
    userProcurementCategoryList,
    userProcurementSubCategoryList
  } = props;
  const initialState: User = {
    id: 0,
    userName: "",
    //mappedCompanies: [],
    userCompanies: [],
    userClusters: [],
    //userRoles: [],
    isActive: true,
    emailAddress: ""
    //grpClusters: [],
  };
  const initialUserCompany: UserCompany = {
    id: 0,
    companyCode: "",
    roleIds: [],
    approvalPointIds: [],
    rmCategoryIds: [],
    procurementCategoryIds: [],
    procurementSubCategoryIds: []
  };
  const initialUserCluster: UserCluster = {
    id: 0,
    clusterId: 0,
    clusterName: "",
    roleIds: [],
    approvalPointIds: [],
    rmCategoryIds: [],
    procurementCategoryIds: [],
    procurementSubCategoryIds: []
  };
  const [newUserCompany, setNewUserCompany] = useState<UserCompany>(initialUserCompany);
  const [newUserCluster, setNewUserCluster] = useState<UserCluster>(initialUserCluster);
  const [formErrors, setFormErrors] = useState<FormError[]>([]);
  const [fistSubmitDone, setFistSubmitDone] = useState(false);
  const [isUpdateOpen, setIsUpdateOpen] = useState(false);
  const [selectedData, setSelectedData] = useState<User>(initialState);
  const validateFieldsData: Array<FormFieldMeta> = [
    {
      fieldName: "emailAddress",
      isRequired: true,
      reuiredMsg: "Email is required",
      formatFunc: FormUtil.isValidEmail.bind(dataObj.emailAddress),
      formatMsg: translation.vendor_crete_form1_emailfomat_error,
    }
    // {
    //   fieldName: "userCompanies",
    //   isRequired: true,
    //   reuiredMsg: "Company code is required",
    //   isList: true,
    // }
    // {
    //   fieldName: "userRoles",
    //   isRequired: true,
    //   reuiredMsg: "User Role is required",
    //   isList: true,
    // },
  ];

  // const [sbuList, setSbuList] = useState<SBU[]>([]);
  // const [userRolesList, setUserRolesList] = useState<UserRole[]>([]);
  // const [clustersList, setClustersList] = useState<Cluster[]>([]);

  const prepareForRequest = () => {
    dispatch(AllActions.backDropActions.openBackDrop());
  };

  const compeleteRequest = (success: boolean, message?: string) => {
    dispatch(AllActions.backDropActions.closeBackDrop());
    if (message) {
      if (success) {
        dispatch(
          AllActions.infoActions.openInforSuccess(
            message,
            InforDisplyaDuration.common
          )
        );
      } else {
        dispatch(
          AllActions.infoActions.openInforError(
            message,
            InforDisplyaDuration.common
          )
        );
      }
    }
  };

  // useEffect(() => {
  //   if (open) {
  //     prepareForRequest();
  //     MasterMetaDataService.getSBUCodes(
  //       function (sbuList: Array<SBU>) {
  //         setSbuList(sbuList);
  //         compeleteRequest(true);
  //       },
  //       function (error: Error) {
  //         setSbuList([]);
  //         compeleteRequest(false);
  //       }
  //     );

  //     MasterMetaDataService.getUserRoles(
  //       function (userRolesist: Array<UserRole>) {
  //         setUserRolesList(userRolesist);
  //         compeleteRequest(true);
  //       },
  //       function (error: Error) {
  //         setUserRolesList([]);
  //         compeleteRequest(false);
  //       }
  //     );

  //     MasterMetaDataService.getClusters(
  //       function (clustersList: Array<Cluster>) {
  //         setClustersList(clustersList);
  //         compeleteRequest(true);
  //       },
  //       function (error: Error) {
  //         setClustersList([]);
  //         compeleteRequest(false);
  //       }
  //     );
  //   }
  // }, [open]);

  const saveObject = (onSaveCallback: (status: boolean) => void) => {
    prepareForRequest();
    MasterDataService.saveUser(
      dataObj,
      function (user: User) {
        if (dataObj.id === 0) {
          compeleteRequest(true, translation.master_user_dialog_save_suc);
          successUpdate(user);
        } else {
          compeleteRequest(true, translation.master_user_dialog_update_suc);
          successUpdate(user);
        }
        onSaveCallback(true);
      },
      function (error: Error) {
        compeleteRequest(false, translation.master_add_dialog_save_error);
        onSaveCallback(false);
      }
    );
  };

  useEffect(() => {
    if (fistSubmitDone) {
      //validateData();
    }
  }, [dataObj]);

  const handleExit = (e: any) => {
    setDataObj(initialState);
    setFormErrors([]);
    setFistSubmitDone(false);
  };

  const validateData = () => {
    var isValid = true;
    //check cluster or company selected
    if ((!dataObj.userCompanies || dataObj.userCompanies.length == 0)
      && (!dataObj.userClusters || dataObj.userClusters.length == 0)) {
      isValid = false;
      dispatch(AllActions.infoActions.openInforError(
        "Please add one or more company or cluster.", InforDisplyaDuration.common));
    }
    //check roles are selected for each company or cluster
    if ((dataObj.userCompanies && dataObj.userCompanies.find(c => { return !c.roleIds || c.roleIds.length == 0; }))
      || (dataObj.userClusters && dataObj.userClusters.find(c => { return !c.roleIds || c.roleIds.length == 0; }))) {
      isValid = false;
      dispatch(AllActions.infoActions.openInforError(
        "Please add one or more roles to the selected company/cluster.", InforDisplyaDuration.common));
    }
    //check rmcategories 
    if ((dataObj.userCompanies && dataObj.userCompanies.find(c => { return c.roleIds.includes(App_Roles.GSSCCategoryLead) && (!c.rmCategoryIds || c.rmCategoryIds.length == 0); }))
      || (dataObj.userClusters && dataObj.userClusters.find(c => { return c.roleIds.includes(App_Roles.GSSCCategoryLead) && (!c.rmCategoryIds || c.rmCategoryIds.length == 0); }))) {
      isValid = false;
      dispatch(AllActions.infoActions.openInforError(
        "Please add one or more RM Categories to the selected role.", InforDisplyaDuration.common));
    }
    if ((dataObj.userCompanies && dataObj.userCompanies.find(c => { return c.roleIds.includes(App_Roles.NMRPCategoryManager) && (!c.procurementCategoryIds || c.procurementCategoryIds.length == 0); }))
      || (dataObj.userClusters && dataObj.userClusters.find(c => { return c.roleIds.includes(App_Roles.NMRPCategoryManager) && (!c.procurementCategoryIds || c.procurementCategoryIds.length == 0); }))) {
      isValid = false;
      dispatch(AllActions.infoActions.openInforError(
        "Please add one or more Procurement Categories to the selected role.", InforDisplyaDuration.common));
    }
    if ((dataObj.userCompanies && dataObj.userCompanies.find(c => { return c.roleIds.includes(App_Roles.NMRPCategoryManager) && (!c.procurementSubCategoryIds || c.procurementSubCategoryIds.length == 0); }))
      || (dataObj.userClusters && dataObj.userClusters.find(c => { return c.roleIds.includes(App_Roles.NMRPCategoryManager) && (!c.procurementSubCategoryIds || c.procurementSubCategoryIds.length == 0); }))) {
      isValid = false;
      dispatch(AllActions.infoActions.openInforError(
        "Please add one or more Procurement Sub Categories to the selected role.", InforDisplyaDuration.common));
    }
    if ((dataObj.userCompanies && dataObj.userCompanies.find(c => { return c.roleIds.includes(App_Roles.NMRPPillarLead) && (!c.procurementSubCategoryIds || c.procurementSubCategoryIds.length == 0); }))
      || (dataObj.userClusters && dataObj.userClusters.find(c => { return c.roleIds.includes(App_Roles.NMRPPillarLead) && (!c.procurementSubCategoryIds || c.procurementSubCategoryIds.length == 0); }))) {
      isValid = false;
      dispatch(AllActions.infoActions.openInforError(
        "Please add one or more Procurement Sub Categories to the selected role.", InforDisplyaDuration.common));
    }
    if ((dataObj.userCompanies && dataObj.userCompanies.find(c => { return c.roleIds.includes(App_Roles.ServicePillarLead) && (!c.procurementSubCategoryIds || c.procurementSubCategoryIds.length == 0); }))
      || (dataObj.userClusters && dataObj.userClusters.find(c => { return c.roleIds.includes(App_Roles.ServicePillarLead) && (!c.procurementSubCategoryIds || c.procurementSubCategoryIds.length == 0); }))) {
      isValid = false;
      dispatch(AllActions.infoActions.openInforError(
        "Please add one or more Procurement Sub Categories to the selected role.", InforDisplyaDuration.common));
    }

    let formValidateData: FormValidateData = FormUtil.validateFields(
      validateFieldsData,
      dataObj
    );

    setFormErrors(formValidateData.errorsList);
    return formValidateData.isValid && isValid;
  };

  const handleSaveAddNew = (e: any) => {
    setFistSubmitDone(true);
    if (validateData()) {
      saveObject(function (status: boolean) {
        if (status) {
          setDataObj(initialState);
          setFormErrors([]);
          setFistSubmitDone(false);
        }
      });
    }
  };

  const handleSaveExit = (e: any) => {
    setFistSubmitDone(true);
    if (validateData()) {
      saveObject(function (status: boolean) {
        //setOpen(false);
        handleClose();
      });
    }
  };

  const setClusterRoles = (clusterId: number, roleIds: number[]) => {
    let userCluster = dataObj.userClusters.find((c) => {
      return c.clusterId == clusterId;
    }) as UserCluster;
    userCluster.roleIds = roleIds;
    setDataObj({
      ...dataObj,
      ["userClusters"]: [...dataObj.userClusters]//create new array of user companies
    });
  };


  /* 
    const setClusterRMCategories = (clusterId: number, rmCategoryIds: number[]) => {
      let userCluster = dataObj.userClusters.find((c) => {
        return c.clusterId == clusterId;
      }) as UserCluster;
      userCluster.rmCategoryIds = rmCategoryIds;
      setDataObj({
        ...dataObj,
        ["userClusters"]: [...dataObj.userClusters]//create new array of user companies
      });
    };
  
    const setClusterProcurementCategories = (clusterId: number, procurementCategoryIds: number[]) => {
      let userCluster = dataObj.userClusters.find((c) => {
        return c.clusterId == clusterId;
      }) as UserCluster;
      userCluster.procurementCategoryIds = procurementCategoryIds;
      setDataObj({
        ...dataObj,
        ["userClusters"]: [...dataObj.userClusters]//create new array of user companies
      });
    };
   */
  const setCompanyRoles = (companyCode: string, roleIds: number[]) => {
    let userCompany = dataObj.userCompanies.find((c) => {
      return c.companyCode == companyCode;
    }) as UserCompany;
    userCompany.roleIds = roleIds;
    setDataObj({
      ...dataObj,
      ["userCompanies"]: [...dataObj.userCompanies]//create new array of user companies
    });
  };

  const setUserRoles = (companyCode: string, clusterId: number, roleIds: number[]) => {
    if (clusterId) {
      setClusterRoles(clusterId, roleIds);
    } else if (companyCode) {
      setCompanyRoles(companyCode, roleIds);
    }
  };

  /*   const setCompanyRMCategories = (companyCode: string, rmCategoryIds: number[]) => {
      let userCompany = dataObj.userCompanies.find((c) => {
        return c.companyCode == companyCode;
      }) as UserCompany;
      userCompany.rmCategoryIds = rmCategoryIds;
      setDataObj({
        ...dataObj,
        ["userCompanies"]: [...dataObj.userCompanies]//create new array of user companies
      });
    };
  
    const setCompanyProcurementCategories = (companyCode: string, procurementCategoryIds: number[]) => {
      let userCompany = dataObj.userCompanies.find((c) => {
        return c.companyCode == companyCode;
      }) as UserCompany;
      userCompany.procurementCategoryIds = procurementCategoryIds;
      setDataObj({
        ...dataObj,
        ["userCompanies"]: [...dataObj.userCompanies]//create new array of user companies
      });
    }; */

  /* const setUserRmCategories = (companyCode: string, clusterId: number, rmCategoryIds: number[]) => {
    if (clusterId) {
      setClusterRMCategories(clusterId, rmCategoryIds);
    } else if (companyCode) {
      setCompanyRMCategories(companyCode, rmCategoryIds);
    }
  };

  const setUserProcurementCategories = (companyCode: string, clusterId: number, procurementCategoryIds: number[]) => {
    if (clusterId) {
      setClusterProcurementCategories(clusterId, procurementCategoryIds);
    } else if (companyCode) {
      setCompanyProcurementCategories(companyCode, procurementCategoryIds);
    }
  };
 */
  const getRoleCount = (companyCode: string, clusterId: number) => {
    if (clusterId) {
      let userCluster = dataObj.userClusters.find((c) => {
        return c.clusterId == clusterId;
      }) as UserCluster;
      return userCluster.roleIds ? userCluster.roleIds.length : 0;
    } else if (companyCode) {
      let userCompany = dataObj.userCompanies.find((c) => {
        return c.companyCode == companyCode;
      }) as UserCompany;
      return userCompany.roleIds ? userCompany.roleIds.length : 0;
    }
    return 0;
  };

  const handleChange = (input: string, companyCode: string, clusterId: number) => (e: any) => {
    if (e.target.type === "checkbox") {
      setDataObj({
        ...dataObj,
        [input]: e.target.checked,
      });
    } else if (input === "userCompanies") {
      setDataObj({
        ...dataObj,
        [input]: [...dataObj.userCompanies, { id: 0, companyCode: e.target.value, roleIds: [] }],
      });
      //setIsRMCategoryVisible(false);
    } else if (input === "userClusters") {
      var grpCluster = clustersList.find(cl => {
        return cl.id == e.target.value;
      });
      setDataObj({
        ...dataObj,
        [input]: [...dataObj.userClusters, { id: 0, clusterId: e.target.value, clusterName: grpCluster?.clusterName, roleIds: [] }],
      });
      //setIsRMCategoryVisible(false);
    } else if (input === "roleIds") {
      if (e.target.value.length > 1 && e.target.value.length > getRoleCount(companyCode, clusterId)) {
        var serviceRole = [App_Roles.NMRPCategoryManager, App_Roles.ServicePillarLead];
        const serviceRoleExist = serviceRole.every(id => e.target.value.includes(id));
        var nonrmRole = [App_Roles.NMRPCategoryManager, App_Roles.NMRPPillarLead];
        const nonrmRoleExist = nonrmRole.every(id => e.target.value.includes(id));
        if (serviceRoleExist || nonrmRoleExist) {
          dispatch(AllActions.infoActions.openInforError(
            translation.master_user_dialog_specificrole_error, InforDisplyaDuration.common));
        }
        else {
          dispatch(
            AllActions.alertDialogActions.openAlertDialog(
              translation.master_user_dialog_multi_role_title,
              translation.master_user_dialog_multi_role_msg,
              translation.master_user_dialog_multi_role_yesbtn,
              function () {
                dispatch(AllActions.alertDialogActions.closeAlertDialog());
                setUserRoles(companyCode, clusterId, e.target.value);
              },
              translation.master_user_dialog_multi_role_nobtn,
              function () {
                dispatch(AllActions.alertDialogActions.closeAlertDialog());
              }
            )
          );
        }
      }
      else {
        setUserRoles(companyCode, clusterId, e.target.value);
      }

    }
    /* else if (input === "rmCategoryIds") {
      setUserRmCategories(companyCode, clusterId, e.target.value);
    }
    else if (input === "procurementCategoryIds") {
      setUserProcurementCategories(companyCode, clusterId, e.target.value);
    } */
    else {
      setDataObj({
        ...dataObj,
        [input]: e.target.value,
      });
    }

  };

  const getErrorState = (input: string) => {
    //return MasterDataUtil.getErrorState(input, formErrors);
    return FormUtil.getErrorState(input, formErrors);
  };

  const getCompayRoles = (companyCode: string) => {
    //remove ES roles if not in supported companies
    if (SCF_ALLOWED_COMPANY_CODES.indexOf(companyCode) < 0) {
      var esRoleId = [ES_Roles.EsHodApprover, ES_Roles.EsRequestor, ES_Roles.EsTeamApprover];
      return userRolesList.filter((r) => { return esRoleId.indexOf(r.id) < 0 });
    }
    return userRolesList;
  };

  const getRoleName = (roleId: number) => {
    return userRolesList.find(v => v.id == roleId)?.roleName;
  };

  /*                                                                              */
  const getRMCategoryNames = (rmCategoryIds: number[]) => {
    return userRmCategoryList.filter(item => rmCategoryIds.includes(item.id))
      .map(item => item.rmCategoryName).join(', ');
  };

  const getProcurementCategoryNames = (procurementCategoryIds: number[]) => {
    return userProcurementCategoryList.filter(item => procurementCategoryIds.includes(item.id))
      .map(item => item.procurementCategoryName).join(', ');
  };
  const getProcurementSubCategoryNames = (procurementSubCategoryIds: number[]) => {
    return userProcurementSubCategoryList.filter(item => procurementSubCategoryIds.includes(item.id))
      .map(item => item.name).join(', ');
  };


  const handleDelete = (
    e: React.MouseEvent,
    value: string | number,
    input: string,
    companyCode: string,
    clusterId: number
  ) => {
    e.preventDefault();
    if (input === "userCompanies") {
      setDataObj({
        ...dataObj,
        [input]: dataObj.userCompanies.filter((cmp) => {
          return cmp.companyCode !== value;
        }),
      });
    } else if (input === "roleIds") {
      if (clusterId) {
        let userCluster = dataObj.userClusters.find((c) => {
          return c.clusterId == clusterId;
        }) as UserCluster;
        userCluster.roleIds = userCluster.roleIds.filter((r) => {
          return r != value;
        });
        if (value == App_Roles.GSSCCategoryLead) {
          userCluster.rmCategoryIds = [];
        }
        if (value == App_Roles.NMRPCategoryManager) {
          userCluster.procurementCategoryIds = [];
          userCluster.procurementSubCategoryIds = [];
        }
        if (value == App_Roles.NMRPPillarLead) {
          let nonRMProcurementCat = userProcurementCategoryList.filter((r) => {
            return r.vendorCategoryId == VendorCategoryData.NonRM;
          });
          userCluster.procurementCategoryIds = userCluster.procurementCategoryIds.filter(item => !nonRMProcurementCat.map(item => item.id).includes(item));
          let nonRMProcurementSubCat = userProcurementSubCategoryList.filter((r) => {
            return userCluster.procurementCategoryIds.includes(r.procurementCategoryId);
          });
          userCluster.procurementSubCategoryIds = userCluster.procurementSubCategoryIds.filter(x => nonRMProcurementSubCat.map(item => item.id).includes(x));
        }
        if (value == App_Roles.ServicePillarLead) {
          let serviceProcurementCat = userProcurementCategoryList.filter((r) => {
            return r.vendorCategoryId == VendorCategoryData.Services;
          });
          userCluster.procurementCategoryIds = userCluster.procurementCategoryIds.filter(item => !serviceProcurementCat.map(item => item.id).includes(item));
          let serviceProcurementSubCat = userProcurementSubCategoryList.filter((r) => {
            return userCluster.procurementCategoryIds.includes(r.procurementCategoryId);
          });
          userCluster.procurementSubCategoryIds = userCluster.procurementSubCategoryIds.filter(x => serviceProcurementSubCat.map(item => item.id).includes(x));
        }
        setDataObj({
          ...dataObj,
          ["userClusters"]: [...dataObj.userClusters]
        });
      } else if (companyCode) {
        let userCompany = dataObj.userCompanies.find((c) => {
          return c.companyCode == companyCode;
        }) as UserCompany;
        userCompany.roleIds = userCompany.roleIds.filter((r) => {
          return r != value;
        });
        if (value == App_Roles.GSSCCategoryLead) {
          userCompany.rmCategoryIds = [];
        }
        if (value == App_Roles.NMRPCategoryManager) {
          userCompany.procurementCategoryIds = [];
          userCompany.procurementSubCategoryIds = [];
        }
        if (value == App_Roles.NMRPPillarLead) {
          let nonRMProcurementCat = userProcurementCategoryList.filter((r) => {
            return r.vendorCategoryId == VendorCategoryData.NonRM;
          });
          userCompany.procurementCategoryIds = userCompany.procurementCategoryIds.filter(item => !nonRMProcurementCat.map(item => item.id).includes(item));
          let nonRMProcurementSubCat = userProcurementSubCategoryList.filter((r) => {
            return userCompany.procurementCategoryIds.includes(r.procurementCategoryId);
          });
          userCompany.procurementSubCategoryIds = userCompany.procurementSubCategoryIds.filter(x => nonRMProcurementSubCat.map(item => item.id).includes(x));
        }
        if (value == App_Roles.ServicePillarLead) {
          let serviceProcurementCat = userProcurementCategoryList.filter((r) => {
            return r.vendorCategoryId == VendorCategoryData.Services;
          });
          userCompany.procurementCategoryIds = userCompany.procurementCategoryIds.filter(item => !serviceProcurementCat.map(item => item.id).includes(item));
          let serviceProcurementSubCat = userProcurementSubCategoryList.filter((r) => {
            return userCompany.procurementCategoryIds.includes(r.procurementCategoryId);
          });
          userCompany.procurementSubCategoryIds = userCompany.procurementSubCategoryIds.filter(x => serviceProcurementSubCat.map(item => item.id).includes(x));
        }
        setDataObj({
          ...dataObj,
          ["userCompanies"]: [...dataObj.userCompanies]
        });
      }
    } else if (input === "userClusters") {
      setDataObj({
        ...dataObj,
        [input]: dataObj.userClusters.filter((cluster) => {
          return cluster.clusterId !== value;
        }),
      });
    }
    /* else if (input === "rmCategoryIds") {
      if (clusterId) {
        let userCluster = dataObj.userClusters.find((c) => {
          return c.clusterId == clusterId;
        }) as UserCluster;
        userCluster.rmCategoryIds = userCluster.rmCategoryIds.filter((r) => {
          return r != value;
        });
        setDataObj({
          ...dataObj,
          ["userClusters"]: [...dataObj.userClusters]
        });
      } else if (companyCode) {
        let userCompany = dataObj.userCompanies.find((c) => {
          return c.companyCode == companyCode;
        }) as UserCompany;
        userCompany.rmCategoryIds = userCompany.rmCategoryIds.filter((r) => {
          return r != value;
        });
        setDataObj({
          ...dataObj,
          ["userCompanies"]: [...dataObj.userCompanies]
        });
      }
    } */
    /* else if (input === "procurementCategoryIds") {
      if (clusterId) {
        let userCluster = dataObj.userClusters.find((c) => {
          return c.clusterId == clusterId;
        }) as UserCluster;
        userCluster.procurementCategoryIds = userCluster.procurementCategoryIds.filter((r) => {
          return r != value;
        });
        setDataObj({
          ...dataObj,
          ["userClusters"]: [...dataObj.userClusters]
        });
      } else if (companyCode) {
        let userCompany = dataObj.userCompanies.find((c) => {
          return c.companyCode == companyCode;
        }) as UserCompany;
        userCompany.procurementCategoryIds = userCompany.procurementCategoryIds.filter((r) => {
          return r != value;
        });
        setDataObj({
          ...dataObj,
          ["userCompanies"]: [...dataObj.userCompanies]
        });
      }
    } */
  };

  /*  const getRoleChecked = (obj: any) => {
     return true;
   }; */

  const getCheckedRole = (ur: UserRole, companyCode: string, clusterId: number) => {
    if (clusterId) {
      let userCluster = dataObj.userClusters.find((c) => {
        return c.clusterId == clusterId;
      }) as UserCluster;
      if (userCluster) {
        let exists = userCluster.roleIds.findIndex((r) => {
          return r === ur.id;
        });
        if (!userCluster.roleIds.includes(App_Roles.GSSCCategoryLead)) {
          userCluster.rmCategoryIds = [];
        }
        if (!userCluster.roleIds.includes(App_Roles.NMRPCategoryManager) && !userCluster.roleIds.includes(App_Roles.NMRPPillarLead) && !userCluster.roleIds.includes(App_Roles.ServicePillarLead)) {
          userCluster.procurementCategoryIds = [];
        }
        return exists !== -1;
      }
      return false;
    } else if (companyCode) {
      let userCompany = dataObj.userCompanies.find((c) => {
        return c.companyCode == companyCode;
      }) as UserCompany;
      if (userCompany) {
        let exists = userCompany.roleIds.findIndex((r) => {
          return r === ur.id;
        });
        if (!userCompany.roleIds.includes(App_Roles.GSSCCategoryLead)) {
          userCompany.rmCategoryIds = [];
        }
        if (!userCompany.roleIds.includes(App_Roles.NMRPCategoryManager) && !userCompany.roleIds.includes(App_Roles.NMRPPillarLead) && !userCompany.roleIds.includes(App_Roles.ServicePillarLead)) {
          userCompany.procurementCategoryIds = [];
        }
        return exists !== -1;
      }
      return false;
    }
  };

  /*  const getCheckedRMCategory = (ur: UserRMCategory, companyCode: string, clusterId: number) => {
     if (clusterId) {
       let userCluster = dataObj.userClusters.find((c) => {
         return c.clusterId == clusterId;
       }) as UserCluster;
       if (userCluster) {
         let exists = userCluster.rmCategoryIds.findIndex((r) => {
           return r === ur.id;
         });
         return exists !== -1;
       }
       return false;
     } else if (companyCode) {
       let userCompany = dataObj.userCompanies.find((c) => {
         return c.companyCode == companyCode;
       }) as UserCompany;
       if (userCompany) {
         let exists = userCompany.rmCategoryIds.findIndex((r) => {
           return r === ur.id;
         });
         return exists !== -1;
       }
       return false;
     }
   }; */

  /*  const getCheckedProcurementCategory = (ur: UserProcurementCategory, companyCode: string, clusterId: number) => {
     if (clusterId) {
       let userCluster = dataObj.userClusters.find((c) => {
         return c.clusterId == clusterId;
       }) as UserCluster;
       if (userCluster) {
         let exists = userCluster.procurementCategoryIds.findIndex((r) => {
           return r === ur.id;
         });
         return exists !== -1;
       }
       return false;
     } else if (companyCode) {
       let userCompany = dataObj.userCompanies.find((c) => {
         return c.companyCode == companyCode;
       }) as UserCompany;
       if (userCompany) {
         let exists = userCompany.procurementCategoryIds.findIndex((r) => {
           return r === ur.id;
         });
         return exists !== -1;
       }
       return false;
     }
   }; */

  const getCheckedCluster = (obj: Cluster) => {
    let exists = dataObj.userClusters.findIndex((cl) => {
      return cl.id == obj.id;
    });
    return exists !== -1;
  };

  const handleEditPopup = (e: React.MouseEvent, cluster: UserCluster[] | [], company: UserCompany[] | []) => {
    setIsUpdateOpen(true);
    let u = {
      id: 0,
      userName: "",
      userCompanies: company,
      userClusters: cluster,
      isActive: true,
      emailAddress: ""
    };
    setSelectedData(u);
  };

  const handleUpdateDialogClose = (e: any) => {
    setIsUpdateOpen(false);
  };

  const copyObj = (user: User) => {
    var copyObj: User = {
      id: user.id,
      userName: user.userName,
      emailAddress: user.emailAddress,
      isActive: user.isActive,
      userClusters: user.userClusters
        ? user.userClusters.map((cl) => {
          return {
            id: cl.id,
            clusterId: cl.clusterId,
            clusterName: cl.clusterName,
            roleIds: cl.roleIds ? [...cl.roleIds] : [],
            approvalPointIds: cl.approvalPointIds ? [...cl.approvalPointIds] : [],
            rmCategoryIds: cl.rmCategoryIds ? [...cl.rmCategoryIds] : [],
            procurementCategoryIds: cl.procurementCategoryIds ? [...cl.procurementCategoryIds] : [],
            procurementSubCategoryIds: cl.procurementSubCategoryIds ? [...cl.procurementSubCategoryIds] : [],
          }
        })
        : [],
      userCompanies: user.userCompanies
        ? user.userCompanies.map((co) => {
          return {
            id: co.id,
            companyCode: co.companyCode,
            roleIds: co.roleIds ? [...co.roleIds] : [],
            approvalPointIds: co.approvalPointIds ? [...co.approvalPointIds] : [],
            rmCategoryIds: co.rmCategoryIds ? [...co.rmCategoryIds] : [],
            procurementCategoryIds: co.procurementCategoryIds ? [...co.procurementCategoryIds] : [],
            procurementSubCategoryIds: co.procurementSubCategoryIds ? [...co.procurementSubCategoryIds] : [],
          }

        })
        : []
    };
    return copyObj;
  };

  const handleSuccessUserUpdate = (user: User) => {
    if (user.userClusters.length > 0) {
      let userCluster = dataObj.userClusters.find((c) => {
        return c.clusterId == user.userClusters[0].clusterId;
      }) as UserCluster;
      userCluster.rmCategoryIds = user.userClusters[0].rmCategoryIds;
      userCluster.procurementCategoryIds = user.userClusters[0].procurementCategoryIds;
      userCluster.procurementSubCategoryIds = user.userClusters[0].procurementSubCategoryIds;
      setDataObj({
        ...dataObj,
        ["userClusters"]: [...dataObj.userClusters]//create new array of user companies
      });
    }
    else {
      let userCompany = dataObj.userCompanies.find((c) => {
        return c.companyCode == user.userCompanies[0].companyCode;
      }) as UserCompany;
      userCompany.rmCategoryIds = user.userCompanies[0].rmCategoryIds;
      userCompany.procurementCategoryIds = user.userCompanies[0].procurementCategoryIds;
      userCompany.procurementSubCategoryIds = user.userCompanies[0].procurementSubCategoryIds;
      setDataObj({
        ...dataObj,
        ["userCompanies"]: [...dataObj.userCompanies]//create new array of user companies
      });
    }
  };

  return (
    <div className={classes.popUpOuter}>
      <Dialog
        open={open}
        onClose={handleClose}
        onExit={handleExit}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
      /* style={{maxWidth:1006} } */
      >
        <DialogTitle className={classes.popUpHeader} id="alert-dialog-title">
          {translation.master_user_dialog_title}
        </DialogTitle>
        <DialogContent className={classes.NoPopWrapper} style={{ width: 912 }}>
          <div>
            <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.createLbl}>
                {translation.master_user_dialog_email}
              </span>
              <div className={classes.inputWrapper_Req}>
                <TextField
                  variant="outlined"
                  value={dataObj.emailAddress || ""}
                  onChange={handleChange("emailAddress", "", 0)}
                  error={getErrorState("emailAddress")}
                />
              </div>
            </Grid>

            {/*//////////////////*/}
            <div className={classes.tblOuterBG}>
              <TableContainer className={classes.tblContainer}>
                <Table size="small" stickyHeader aria-label="sticky table">
                  <TableHead className={classes.tblHeader}>
                    <TableRow>
                      <TableCell width={100}>Company</TableCell>
                      <TableCell width={300}>Roles</TableCell>
                      <TableCell width={200}>RM Category</TableCell>
                      <TableCell width={200}>Procurement Category</TableCell>
                      <TableCell width={200}>Procurement Sub Category</TableCell>
                      <TableCell width={30}></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody className={classes.tblBody}>
                    {dataObj.userCompanies &&
                      dataObj.userCompanies.map((userCompany, index) => {
                        return (
                          <TableRow key={userCompany.companyCode}>
                            <TableCell>
                              <Grid item xs={12} sm={12} md={12} lg={12}>
                                <div className={classes.inputWrapper_Req}>
                                  {userCompany.companyCode}
                                </div>
                              </Grid>
                            </TableCell>
                            <TableCell>
                              <div className={classes.inputWrapper_Req} style={{ width: 300 }}>
                                <Select
                                  variant="outlined"
                                  multiple
                                  value={userCompany.roleIds || []}
                                  onChange={handleChange("roleIds", userCompany.companyCode, 0)}
                                  error={getErrorState("roleIds")}
                                  renderValue={(selected) => (
                                    <div>
                                      {(selected as number[]).map((roleId) => (
                                        <Chip
                                          key={roleId}
                                          label={getRoleName(roleId)}
                                          clickable
                                          deleteIcon={
                                            <CancelIcon
                                              onMouseDown={(event) => event.stopPropagation()}
                                            />
                                          }
                                          onDelete={(e) =>
                                            handleDelete(e, roleId, "roleIds", userCompany.companyCode, 0)
                                          }
                                          onClick={() => console.log("clicked chip")}
                                        />
                                      ))}
                                    </div>
                                  )}
                                >
                                  {getCompayRoles(userCompany.companyCode).map((obj, index) => (
                                    <MenuItem key={obj.id} value={obj.id}>
                                      <Checkbox checked={getCheckedRole(obj, userCompany.companyCode, 0)} />
                                      <ListItemText primary={obj.roleName} />
                                    </MenuItem>
                                  ))}
                                </Select>
                              </div>
                            </TableCell>
                            {/*  RmCategory */}
                            {userCompany.roleIds.includes(App_Roles.GSSCCategoryLead) ? (
                              <TableCell>
                                {/* <div className={classes.inputWrapper_Req} style={{width:200}}>
                          <Select
                            variant="outlined"
                            multiple
                            value={userCompany.rmCategoryIds || []}
                            onChange={handleChange("rmCategoryIds", userCompany.companyCode, 0)}
                            error={getErrorState("rmCategoryIds")}
                            renderValue={(selected) => (
                              <div>
                                {(selected as number[]).map((rmCategoryId) => (
                                  <Chip
                                    key={rmCategoryId}
                                    label={getRMCategoryName(rmCategoryId)}
                                    clickable
                                    deleteIcon={
                                      <CancelIcon
                                        onMouseDown={(event) => event.stopPropagation()}
                                      />
                                    }
                                    onDelete={(e) =>
                                      handleDelete(e, rmCategoryId, "rmCategoryIds", userCompany.companyCode,0)
                                    }
                                    onClick={() => console.log("clicked chip")}
                                  />
                                ))}
                              </div>
                            )}
                          >
                            {userRmCategoryList.map((obj, index) => (
                              <MenuItem key={obj.id} value={obj.id}>
                                <Checkbox checked={getCheckedRMCategory(obj, userCompany.companyCode, 0)} />
                                <ListItemText primary={obj.rmCategoryName} />
                              </MenuItem>
                            ))}
                          </Select>
                        </div> */}
                                <label>{getRMCategoryNames(userCompany.rmCategoryIds)}</label>
                              </TableCell>
                            ) : (<TableCell></TableCell>)}
                            {/* {----Procurement Category----} */}
                            {(userCompany.roleIds.includes(App_Roles.NMRPCategoryManager) || userCompany.roleIds.includes(App_Roles.NMRPPillarLead) || userCompany.roleIds.includes(App_Roles.ServicePillarLead)) ? (
                              <TableCell>
                                {/* <div className={classes.inputWrapper_Req} style={{width:200}}>
                          <Select
                            variant="outlined"
                            multiple
                            value={userCompany.procurementCategoryIds || []}
                            onChange={handleChange("procurementCategoryIds", userCompany.companyCode, 0)}
                            error={getErrorState("procurementCategoryIds")}
                            renderValue={(selected) => (
                              <div>
                                {(selected as number[]).map((procurementCategoryId) => (
                                  <Chip
                                    key={procurementCategoryId}
                                    label={getProcurementCategoryName(procurementCategoryId)}
                                    clickable
                                    deleteIcon={
                                      <CancelIcon
                                        onMouseDown={(event) => event.stopPropagation()}
                                      />
                                    }
                                    onDelete={(e) =>
                                      handleDelete(e, procurementCategoryId, "procurementCategoryIds", userCompany.companyCode,0)
                                    }
                                    onClick={() => console.log("clicked chip")}
                                  />
                                ))}
                              </div>
                            )}
                          >
                            {userProcurementCategoryList.map((obj, index) => (
                              <MenuItem key={obj.id} value={obj.id}>
                                <Checkbox checked={getCheckedProcurementCategory(obj, userCompany.companyCode, 0)} />
                                <ListItemText primary={obj.procurementCategoryName} />
                              </MenuItem>
                            ))}
                          </Select>
                        </div> */}
                                <label>{getProcurementCategoryNames(userCompany.procurementCategoryIds)}</label>
                              </TableCell>
                            ) : (<TableCell></TableCell>)}
                            {(userCompany.roleIds.includes(App_Roles.NMRPCategoryManager) || userCompany.roleIds.includes(App_Roles.NMRPPillarLead) || userCompany.roleIds.includes(App_Roles.ServicePillarLead)) ? (
                              <TableCell>
                                <label>{getProcurementSubCategoryNames(userCompany.procurementSubCategoryIds)}</label>
                              </TableCell>
                            ) : (<TableCell></TableCell>)}

                            <TableCell>
                              <div className={classes.rejectBtn}>
                                <button onClick={(e) => handleDelete(e, userCompany.companyCode, "userCompanies", "", 0)}>
                                  <HighlightOffOutlinedIcon></HighlightOffOutlinedIcon>
                                </button>
                              </div>
                            </TableCell>
                            {(userCompany.roleIds.includes(App_Roles.GSSCCategoryLead) || userCompany.roleIds.includes(App_Roles.NMRPCategoryManager) || userCompany.roleIds.includes(App_Roles.NMRPPillarLead) || userCompany.roleIds.includes(App_Roles.ServicePillarLead)) ? (
                              <TableCell>
                                <div className={classes.editBtn}>
                                  <button onClick={(e) => handleEditPopup(e, [], [userCompany])}>
                                    <EditIcon></EditIcon>
                                  </button>
                                </div>
                              </TableCell>) : <TableCell></TableCell>}
                          </TableRow>);
                      })}
                    <TableRow key={"new"}>
                      <TableCell>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                          <div className={classes.inputWrapper_Req}>
                            <Select
                              variant="outlined"
                              value={newUserCompany.companyCode}
                              onChange={handleChange("userCompanies", "", 0)}
                              error={getErrorState("userCompanies")}
                            >
                              {sbuList.filter((sbu) => {
                                return dataObj.userCompanies.find((uc) => {
                                  return sbu.code == uc.companyCode;
                                }) ? false : true;
                              })
                                .map((obj, index) => (
                                  <MenuItem key={obj.code} value={obj.code}>
                                    <ListItemText primary={obj.name} />
                                  </MenuItem>
                                ))}
                            </Select>
                          </div>
                        </Grid>
                      </TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
            <div className={classes.tblOuterBG}>
              <TableContainer className={classes.tblContainer}>
                <Table size="small" stickyHeader aria-label="sticky table">
                  <TableHead className={classes.tblHeader}>
                    <TableRow>
                      <TableCell width={100}>Cluster</TableCell>
                      <TableCell width={300}>Roles</TableCell>
                      <TableCell width={200}>RM Category</TableCell>
                      <TableCell width={200}>Procurement Category</TableCell>
                      <TableCell width={200}>Procurement Sub Category</TableCell>
                      <TableCell width={30}></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody className={classes.tblBody}>
                    {dataObj.userClusters &&
                      dataObj.userClusters.map((userCluster, index) => {
                        return (
                          <TableRow key={userCluster.clusterId}>
                            <TableCell>
                              <Grid item xs={12} sm={12} md={12} lg={12}>
                                <div className={classes.inputWrapper_Req}>
                                  {userCluster.clusterName}
                                </div>
                              </Grid>
                            </TableCell>
                            <TableCell>
                              <div className={classes.inputWrapper_Req} style={{ width: 300 }}>
                                <Select
                                  variant="outlined"
                                  multiple
                                  value={userCluster.roleIds || []}
                                  onChange={handleChange("roleIds", "", userCluster.clusterId)}
                                  error={getErrorState("roleIds")}
                                  renderValue={(selected) => (
                                    <div>
                                      {(selected as number[]).map((roleId) => (
                                        <Chip
                                          key={roleId}
                                          label={getRoleName(roleId)}
                                          clickable
                                          deleteIcon={
                                            <CancelIcon
                                              onMouseDown={(event) => event.stopPropagation()}
                                            />
                                          }
                                          onDelete={(e) =>
                                            handleDelete(e, roleId, "roleIds", "", userCluster.clusterId)
                                          }
                                          onClick={() => console.log("clicked chip")}
                                        />
                                      ))}
                                    </div>
                                  )}
                                >
                                  {userRolesList.map((obj, index) => (
                                    <MenuItem key={obj.id} value={obj.id}>
                                      <Checkbox checked={getCheckedRole(obj, "", userCluster.clusterId)} />
                                      <ListItemText primary={obj.roleName} />
                                    </MenuItem>
                                  ))}
                                </Select>
                              </div>
                            </TableCell>
                            {/* RMCategory */}
                            {userCluster.roleIds.includes(App_Roles.GSSCCategoryLead) ? (
                              <TableCell>
                                {/* <div className={classes.inputWrapper_Req} style={{width:200}}>
                           <Select
                            variant="outlined"
                            multiple
                            value={userCluster.rmCategoryIds || []}
                            onChange={handleChange("rmCategoryIds","", userCluster.clusterId)}
                            error={getErrorState("rmCategoryIds")}
                            renderValue={(selected) => (
                              <div>
                                {(selected as number[]).map((categoryId) => (
                                  <Chip
                                    key={categoryId}
                                    label={getRMCategoryName(categoryId)}
                                    clickable
                                    deleteIcon={
                                      <CancelIcon
                                        onMouseDown={(event) => event.stopPropagation()}
                                      />
                                    }
                                    onDelete={(e) =>
                                      handleDelete(e, categoryId, "rmCategoryIds", "", userCluster.clusterId)
                                    }
                                    onClick={() => console.log("clicked chip")}
                                  />
                                ))}
                              </div>
                            )}
                          >
                            {userRmCategoryList.map((obj, index) => (
                              <MenuItem key={obj.id} value={obj.id}>
                                <Checkbox checked={getCheckedRMCategory(obj, "", userCluster.clusterId)} />
                                <ListItemText primary={obj.rmCategoryName} />
                              </MenuItem>
                            ))}
                          </Select> */}
                                {/*  </div> */}
                                <label>{getRMCategoryNames(userCluster.rmCategoryIds)}</label>
                              </TableCell>
                            ) : (<TableCell></TableCell>)}
                            {/* ProcurementCategory */}
                            {(userCluster.roleIds.includes(App_Roles.NMRPCategoryManager) || userCluster.roleIds.includes(App_Roles.NMRPPillarLead) || userCluster.roleIds.includes(App_Roles.ServicePillarLead)) ? (
                              <TableCell>
                                {/* <div className={classes.inputWrapper_Req} style={{width:200}}>
                          <Select
                            variant="outlined"
                            multiple
                            value={userCluster.procurementCategoryIds || []}
                            onChange={handleChange("procurementCategoryIds","", userCluster.clusterId)}
                            error={getErrorState("procurementCategoryIds")}
                            renderValue={(selected) => (
                              <div>
                                {(selected as number[]).map((procurementCategoryId) => (
                                  <Chip
                                    key={procurementCategoryId}
                                    label={getProcurementCategoryName(procurementCategoryId)}
                                    clickable
                                    deleteIcon={
                                      <CancelIcon
                                        onMouseDown={(event) => event.stopPropagation()}
                                      />
                                    }
                                    onDelete={(e) =>
                                      handleDelete(e, procurementCategoryId, "procurementCategoryIds", "", userCluster.clusterId)
                                    }
                                    onClick={() => console.log("clicked chip")}
                                  />
                                ))}
                              </div>
                            )}
                          >
                            {userProcurementCategoryList.map((obj, index) => (
                              <MenuItem key={obj.id} value={obj.id}>
                                <Checkbox checked={getCheckedProcurementCategory(obj, "", userCluster.clusterId)} />
                                <ListItemText primary={obj.procurementCategoryName} />
                              </MenuItem>
                            ))}
                          </Select>
                        </div> */}
                                <label>{getProcurementCategoryNames(userCluster.procurementCategoryIds)}</label>
                              </TableCell>
                            ) : <TableCell></TableCell>}

                            {(userCluster.roleIds.includes(App_Roles.NMRPCategoryManager) || userCluster.roleIds.includes(App_Roles.NMRPPillarLead) || userCluster.roleIds.includes(App_Roles.ServicePillarLead)) ? (
                              <TableCell>
                                <label>{getProcurementSubCategoryNames(userCluster.procurementSubCategoryIds)}</label>
                              </TableCell>
                            ) : <TableCell></TableCell>}
                            <TableCell>
                              <div className={classes.rejectBtn}>
                                <button onClick={(e) => handleDelete(e, userCluster.clusterId, "userClusters", "", 0)}>
                                  <HighlightOffOutlinedIcon></HighlightOffOutlinedIcon>
                                </button>
                              </div>
                            </TableCell>
                            {(userCluster.roleIds.includes(App_Roles.GSSCCategoryLead) || userCluster.roleIds.includes(App_Roles.NMRPCategoryManager) || userCluster.roleIds.includes(App_Roles.NMRPPillarLead) || userCluster.roleIds.includes(App_Roles.ServicePillarLead)) ? (
                              <TableCell>
                                <div className={classes.editBtn}>
                                  <button onClick={(e) => handleEditPopup(e, [userCluster], [])}>
                                    <EditIcon></EditIcon>
                                  </button>
                                </div>
                              </TableCell>) : <TableCell></TableCell>}
                          </TableRow>);
                      })}
                    <TableRow key={"new"}>
                      <TableCell>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                          <div className={classes.inputWrapper_Req}>
                            <Select
                              variant="outlined"
                              value={newUserCluster.clusterId}
                              onChange={handleChange("userClusters", "", 0)}
                              error={getErrorState("userClusters")}
                            >
                              {clustersList.filter((cl) => {
                                return dataObj.userClusters.find((ucl) => {
                                  return cl.id == ucl.clusterId;
                                }) ? false : true;
                              })
                                .map((obj, index) => (
                                  <MenuItem key={obj.id} value={obj.id}>
                                    <ListItemText primary={obj.clusterName} />
                                  </MenuItem>
                                ))}
                            </Select>
                          </div>
                        </Grid>
                      </TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </div>

          </div>
        </DialogContent>
        <DialogActions>
          <Grid style={{
            width: "50%",
            float: "left",
            margin: "5px 0px 25px 0px",
          }}
          >
            <span className={classes.createLbl} style={{ width: "20%" }}>
              {translation.master_user_dialog_isactive}
            </span>
            <div>
              <Switch
                checked={dataObj.isActive}
                onChange={handleChange("isActive", "", 0)}
              ></Switch>
            </div>
          </Grid>
          <div style={{ margin: "20px ​10px 15px 0" }}>
            <div className={classes.greenBtnWrapper}>
              <Button onClick={handleSaveAddNew} color="primary">
                <CheckCircleIcon></CheckCircleIcon>
                {translation.master_add_dialog_save_add_btntxt}
              </Button>
            </div>
            <div className={classes.greenBtnWrapper}>
              <Button onClick={handleSaveExit} color="primary">
                <CheckCircleIcon></CheckCircleIcon>
                {translation.master_add_dialog_save_exit_btntxt}
              </Button>
            </div>
            <div className={classes.grayBtnWrapper}>
              <Button onClick={handleClose} color="primary" autoFocus>
                {translation.master_add_dialog_cancelbtntxt}
              </Button>
            </div>
          </div>
        </DialogActions>
      </Dialog>

      <div>
        <CategoryAddDialog
          open={isUpdateOpen}
          dataObj={copyObj(selectedData)}
          /* sbuList={sbuList}
           userRolesList={userRolesList}
           clustersList={clustersList}*/
          setDataObj={setSelectedData}
          handleClose={handleUpdateDialogClose}
          successUpdate={handleSuccessUserUpdate}
          userRmCategoryList={userRmCategoryList}
          userProcurementCategoryList={userProcurementCategoryList}
          userProcurementSubCategoryList={userProcurementSubCategoryList}
        ></CategoryAddDialog>
      </div>
    </div>
  );
}
